import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import "../../wepcg/sidebar/css/wepcg_bar.css"
import Help_hints from "../../wepcg/sidebar/help_hints";

class MissingGoodsBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Missing Goods</strong></h1>
            <p>
                This claim type is used if the goods invoiced did not arrive at all or are incomplete. Before submitting a dispute please check Order Visibility Portal whether delivery is still in transit and what is the planned delivery date. If goods arrived but incomplete, POD needs to be signed with reservation or a damage/loss protocol signed by driver and consignee . If it does not please explain in comments why loss could not be detected at the point of delivery and attach photos of the impacted cases (e.g. photos from unpacking when cargo is detected missing from a pallet, photo of any boxes with cut seals, photos of any detected empty boxes, ...). It must be clear from photos and consignee's review, whether cargo showed any signs of manipulation before the delivery or if the pallets/boxes were 100% intact. For empty boxes and any missing cargo from pallets, please provide also photos of the box labels and pallet labels. We ask you to submit the claim as soon as possible, latest in 5 business days after the delivery (POD date) . Please contact our financial claims team in case there is any question or problem.
            </p>
            <Help_hints />
        </div>
    }
}

export default MissingGoodsBar;